<template>
  <pf-empty-state v-if="!ready">
    <pf-empty-state-header :title="$t('Stiamo caricando il wizard...')" heading-level="h4">
      <template #icon>
        <pf-empty-state-icon>
          <pf-spinner />
        </pf-empty-state-icon>
      </template>
    </pf-empty-state-header>
    <pf-empty-state-body>
      {{ $t('Ancora pochi istanti e potrai costruire la tua offerta.') }}
    </pf-empty-state-body>
  </pf-empty-state>

  <template v-else>
    <wizard-progress />
    <wizard-step-clienti v-if="askClienti && isFirstIteration && !modal" />
    <wizard-step-scopo v-if="!modal" />
    <wizard-step-dominio />
    <wizard-step-prodotti-infrastruttura />
    <wizard-step-stack />
    <wizard-step-configurazione />
    <wizard-step-trasferimenti v-if="askClienti" />
    <wizard-step-location />
    <wizard-step-addon />
    <wizard-step-add />
    <wizard-step-summary />
    <wizard-step-thankyou />
  </template>
</template>

<style scoped>
:deep(.pf-v6-c-radio) {
  margin-bottom: var(--pf-t--global--spacer--sm);
}
</style>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import { useWizardSetup, type Paths } from '@/wizard';
import WizardProgress from './wizard-progress.vue';
import WizardStepScopo from './steps/wizard-step-scopo.vue';
import WizardStepLocation from './steps/wizard-step-location.vue';
import WizardStepProdottiInfrastruttura from './steps/wizard-step-prodotti-infrastruttura.vue';
import WizardStepStack from './steps/wizard-step-stack.vue';
import WizardStepConfigurazione from './steps/wizard-step-configurazione.vue';
import WizardStepTrasferimenti from './steps/wizard-step-trasferimenti.vue';
import WizardStepDominio from './steps/wizard-step-dominio.vue';
import WizardStepAddon from './steps/wizard-step-addon.vue';
import WizardStepClienti from './steps/wizard-step-clienti.vue';
import WizardStepAdd from './steps/wizard-step-add.vue';
import WizardStepSummary from './steps/wizard-step-summary.vue';
import WizardStepThankyou from './steps/wizard-step-thankyou.vue';

export default defineComponent({
  name: 'Wizard',

  inheritAttrs: false,

  components: {
    WizardProgress,
    WizardStepScopo,
    WizardStepLocation,
    WizardStepProdottiInfrastruttura,
    WizardStepStack,
    WizardStepConfigurazione,
    WizardStepTrasferimenti,
    WizardStepDominio,
    WizardStepAddon,
    WizardStepClienti,
    WizardStepAdd,
    WizardStepSummary,
    WizardStepThankyou,
  },

  props: {
    searchedDomain: {
      type: String as PropType<string | null>,
      default: null,
    },
    availableDomain: {
      type: Boolean as PropType<boolean | null>,
      default: null,
    },
    path: {
      type: String as PropType<keyof Paths | null | undefined>,
      default: null,
    },
  },

  setup(props) {
    return useWizardSetup({
      searchedDomain: props.searchedDomain,
      availableDomain: props.availableDomain,
      singlePath: props.path,
    });
  },
});
</script>
